import React from 'react';
import { IOS_APP_URL, ANDROID_APP_URL } from '../../storeLinks';

function StoreButtons({ className }) {
    return (
        <ul className={className}>
            <li>
                <a href={IOS_APP_URL}>
                    <i className="fab fa-apple" /> Download for iOS
                </a>
            </li>
            <li>
                <a className="item-2" href={ANDROID_APP_URL}>
                    <i className="fab fa-google-play" /> Download for Android
                </a>
            </li>
        </ul>
    );
}

export default StoreButtons;
